import { pipe } from './pipe';
import { stringToBoolean } from './string-to-boolean';
import { stringToNumber } from './string-to-number';

export const getUrlParams = () => {
  if (!window?.location) {
    return {};
  }

  const paramsStr = window.location.search.replace('?', '');
  const params = paramsStr.split('&').reduce((obj: any, param) => {
    const arr: string[] = param.split('=');

    const transformValue = pipe(stringToNumber, stringToBoolean);

    const key = arr[0];
    const value = transformValue(arr[1]);

    obj[key] = value;

    return obj;
  }, {});

  return params;
};
